import { Button, Separator } from "@getgreenline/blaze-ui";

type CampaignFooterProps = {
  currentStep: number;
  totalSteps: number;
  nextLabel: string;
  canProceed: boolean;
  isSubmitting?: boolean;
  onBack?: () => void;
  onNext: () => void;
};

export function CampaignFooter({
  currentStep,
  nextLabel,
  canProceed,
  isSubmitting = false,
  onBack,
  onNext,
}: CampaignFooterProps) {
  return (
    <div className="tw:mt-6 tw:px-6 tw:pb-0 sm:tw:px-8 tw:mb-3 tw:w-full">
      <div className="tw:w-full">
        <Separator className="tw:mb-4" />
      </div>
      <div className="tw:flex tw:w-full tw:items-center tw:justify-between tw:gap-4">
        {currentStep > 1 ? (
          <Button
            variant="outline"
            className="tw:cursor-pointer"
            onClick={onBack}
          >
            ← Back
          </Button>
        ) : (
          <div />
        )}
        <div className="tw:flex tw:items-center tw:gap-3">
          <Button
            onClick={onNext}
            disabled={!canProceed || isSubmitting}
            aria-disabled={!canProceed || isSubmitting}
            className={
              canProceed && !isSubmitting
                ? "tw:cursor-pointer"
                : "tw:cursor-pointer tw:opacity-70"
            }
          >
            {nextLabel} →
          </Button>
        </div>
      </div>
    </div>
  );
}
